import { render } from "./AuthAdd.vue?vue&type=template&id=bdfd58cc&scoped=true"
import script from "./AuthAdd.vue?vue&type=script&lang=js"
export * from "./AuthAdd.vue?vue&type=script&lang=js"

import "./AuthAdd.vue?vue&type=style&index=0&id=bdfd58cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdfd58cc"]])

export default __exports__